export const testimonials = [
  {
    name: "游戏达人小王",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20headshot%20casual%20style%20confident%20smile%20professional%20headshot%20studio%20lighting%20clean%20background%20warm%20tones%20friendly%20expression&width=120&height=120&seq=testimonial-avatar-01&orientation=squarish",
    rating: 5,
    comment: "17c每日大赛真的太上头了！每天都有新赛事，奖励也很实在。上个月我靠参加知识竞赛赢了一台新耳机，同事都羡慕死了。平台操作很流畅，客服响应也快，五星好评！",
    date: "2026-08-02",
    achievement: "月度知识竞赛冠军",
  },
  {
    name: "学生党小李",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20college%20student%20female%20portrait%20headshot%20natural%20look%20bright%20smile%20studio%20lighting%20clean%20simple%20background%20warm%20tones&width=120&height=120&seq=testimonial-avatar-02&orientation=squarish",
    rating: 5,
    comment: "作为一名学生，课余时间参加17c每日大赛成了我的日常。每天花个20分钟，既放松心情又能赢奖品。最喜欢休闲挑战模式，简单有趣不费脑，推荐给所有同学！",
    date: "2026-07-30",
    achievement: "连续参赛100天",
  },
  {
    name: "职场人阿杰",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20in%2030s%20portrait%20headshot%20business%20casual%20friendly%20expression%20studio%20lighting%20clean%20background%20warm%20tones%20confident&width=120&height=120&seq=testimonial-avatar-03&orientation=squarish",
    rating: 4,
    comment: "工作压力大的时候就来17c打两场比赛，排解压力效果一流。平台的匹配机制做得不错，很少遇到实力差距过大的情况。给四星是希望以后能增加更多职场人群喜欢的赛事类型。",
    date: "2026-07-28",
    achievement: "高级竞技场资深玩家",
  },
  {
    name: "宝妈小陈",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20headshot%20warm%20motherly%20smile%20natural%20studio%20lighting%20clean%20simple%20background%20friendly%20expression&width=120&height=120&seq=testimonial-avatar-04&orientation=squarish",
    rating: 5,
    comment: "带娃间隙参加17c的比赛是我每天的小确幸。时间灵活，想参加就参加，不想参加也不会有什么损失。而且通过比赛认识了很多志同道合的朋友，大家一起交流心得特别开心。",
    date: "2026-07-25",
    achievement: "社区活跃之星",
  },
];

export const stats = [
  { label: "注册用户", value: "500万+", icon: "ri-user-smile-line" },
  { label: "每日赛事", value: "100+", icon: "ri-calendar-event-line" },
  { label: "累计奖励", value: "1000万+", icon: "ri-gift-line" },
  { label: "用户好评", value: "98%", icon: "ri-thumb-up-line" },
];